import { twMerge } from 'tailwind-merge';

export interface StrapiImageBlockData {
  altText: string;
  linkURL: string;
  linkTarget: string;
  rounded: boolean;
  imgURLs: {
    default: string;
    full: string;
    xl: string;
    lg: string;
    md: string;
    sm: string;
    xs: string;
  };
  padding: {
    top: string;
    right: string;
    bottom: string;
    left: string;
  };
}

export default function ImageBlock({ data }: { data: StrapiImageBlockData }) {
  const paddingClass =
    data.padding &&
    `p-0 pt-${data.padding.top} md:pr-${data.padding.right} pb-${data.padding.bottom} md:pl-${data.padding.left} `;
  return (
    <div className={`${paddingClass} flex justify-center`}>
      <div
        className={twMerge(
          'mx-auto flex w-full justify-center overflow-hidden',
          data.rounded && 'rounded-3xl'
        )}
      >
        <a href={data.linkURL} target={data.linkTarget || '_self'}>
          <picture>
            <source media='(maxwidth:480px)' srcSet={data.imgURLs.xs} />
            <source media='(max-width:640px)' srcSet={data.imgURLs.sm} />
            <source media='(max-width:768px)' srcSet={data.imgURLs.md} />
            <source media='(max-width:1024px)' srcSet={data.imgURLs.lg} />
            <source media='(max-width:1296px)' srcSet={data.imgURLs.xl} />
            <source media='(min-width:1297px)' srcSet={data.imgURLs.full} />
            <img
              src={data.imgURLs.default}
              alt={data.altText}
              style={{ width: 'auto', height: 'auto' }}
            />
          </picture>
        </a>
      </div>
    </div>
  );
}
